import useTranslate from '../../../i18n/useTranslate'
import { Form as FinalForm } from 'react-final-form'
import { Button, Grid, makeStyles } from '@material-ui/core'

import MyTextfield from '../../../control/textfield/textfield'
import MySelect from '../../../control/select/select'
import MyDatePicker from '../../../control/datepicker/datepicker'

import useProjectType from '../../../services/um/lookups/useProjectType'
import { ClosedKeywordType } from '../../../services/um/useSearchClosed'
import CalendarTodayIcon from '@material-ui/icons/CalendarToday'
import { FormApi } from 'final-form'
import { useState } from 'react'
import moment from 'moment'

type ClosePanelComponentProps = {
    onSubmit: (value: ClosedKeywordType) => void
    initialValue: ClosedKeywordType
    onClear: (form: any) => void
}

const Panel = ({ onSubmit, initialValue, onClear }: ClosePanelComponentProps) => {
    const classes = useStyles()
    const translate = useTranslate()
    const { projectT } = useProjectType()
    const [endDate, setEndDate] = useState<string | null>(moment(new Date()).format('YYYY-MM-DD'))
    let defaultProjectType = initialValue.projectType ? [initialValue.projectType] : undefined

    const handleStartDateChange = (form: FormApi<ClosedKeywordType>, value: string | null) => {
        if (value && endDate) {
            let isStartAfter = moment(value).isAfter(endDate)
            if (isStartAfter) {
                form.change('endDate', new Date(value))
            }
        }
    }

    const handleEndDateChange = (value: string | null) => {
        setEndDate(value)
    }

    return (
        <Grid className={classes.root}>
            <FinalForm onSubmit={onSubmit} initialValues={initialValue}>
                {({ handleSubmit, form, values }) => {
                    return (
                        <Grid container spacing={2} className={classes.container}>
                            <Grid item xs={12} sm={6}>
                                <MyTextfield
                                    name="keyword"
                                    materialInputProps={{
                                        disabled: false,
                                        label: translate.get('UM.CLOSED.KEYWORD.LABEL'),
                                        placeholder: translate.get('UM.CLOSED.KEYWORD.PLACEHOLDER'),
                                        size: 'small',
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <MySelect
                                    name="projectType"
                                    label={translate.get('UM.CLOSED.PROJEC_TTYPE.LABEL')}
                                    option={[
                                        {
                                            value: null,
                                            label: translate.get('LABEL.NOT_SPECIFIC'),
                                        },
                                        ...projectT,
                                    ]}
                                    size="small"
                                    placeholder={translate.get('UM.CLOSED.PROJEC_TTYPE.PLACEHOLDER')}
                                    defaultValue={defaultProjectType}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <MyDatePicker
                                    name="startDate"
                                    label={translate.get('UM.CLOSED.STARTDATE.LABEL')}
                                    onChangeValue={(val: string) => handleStartDateChange(form, val)}
                                    size="small"
                                    icon={<CalendarTodayIcon color="disabled" />}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <MyDatePicker
                                    name="endDate"
                                    label={translate.get('UM.CLOSED.ENDDATE.LABEL')}
                                    minDate={new Date(values.startDate)}
                                    onChangeValue={handleEndDateChange}
                                    size="small"
                                    icon={<CalendarTodayIcon color="disabled" />}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container justify="flex-end" spacing={2}>
                                    <Grid item>
                                        <Button
                                            size={'large'}
                                            fullWidth
                                            variant="contained"
                                            color="default"
                                            onClick={() => onClear(form)}
                                        >
                                            {translate.get('BUTTON.RESET')}
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            size={'large'}
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            onClick={handleSubmit}
                                        >
                                            {translate.get('BUTTON.SEARCH')}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )
                }}
            </FinalForm>
        </Grid>
    )
}

const useStyles = makeStyles(() => ({
    container: {
        padding: '1.7rem',
    },
    root: {
        width: '100%',
    },
}))

export default Panel
